import { Type } from 'class-transformer';
import { ExamGrade } from './exam-grade.entity';

export class ExamGradeUpsertDto {
    
    @Type(() => ExamGrade)
    g: ExamGrade;

    examId = 0;

    constructor(g: ExamGrade, examId: number) {
        this.g = g;
        this.examId = examId;
    }
}
